define([
    "dojo/_base/declare",
    "dojo/_base/lang",
    "csi/action/PopupController",
    "csi/def/ViewRef",
    "csi/xml",
    "csi/xml/Search"
], function(declare,lang,PopupController,ViewRef,xml,Search) {

    return declare(PopupController, {

        _preAction: function() {
            // summary: fund the SeasonAvailability node for correct season and material
            var self = this;
            var s = new Search().byType("MaterialSeasonAvailability");
            s.getQuery().RefAttr("AvailabilityProduct", xml.OP_EQUALS, this.m_urlNode)
                        .RefAttr("AvailabilitySeason", xml.OP_EQUALS, this.m_urlParent);

            return this.m_cache.addRequestDeferred(s.getRequest()).then(function(response) {
                var seasonAvailability = response.getResultNode();
                if (seasonAvailability) {
                    self._seasonAvailabilityURL = seasonAvailability.$URL;
                }
            });
        },

        getActionView: function(/*ViewRef?*/vr) {
            // summary: return SeasonAvailbility view
            return this.inherited(arguments, [lang.mixin(new ViewRef(), {
                m_url: this._seasonAvailabilityURL,
                m_id: "Availability"
            })]);
        }

    });
});
